import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Dashboard } from './Dashboard';
import { HistoryView } from './HistoryView';
import { MainDashboard } from './MainDashboard';
import { Impressum } from './Impressum';
import { MachineData } from '../types/types';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './UI/Tabs';
interface LayoutProps {
  selectedMachine: string;
  setSelectedMachine: (id: string) => void;
  machineData: MachineData[];
  showMainDashboard: boolean;
  setShowMainDashboard: (show: boolean) => void;
}
export const Layout: React.FC<LayoutProps> = ({
  selectedMachine,
  setSelectedMachine,
  machineData,
  showMainDashboard,
  setShowMainDashboard
}) => {
  const [showImpressum, setShowImpressum] = useState(false);
  const machine = machineData.find(m => m.id === selectedMachine);
  return <div className="flex flex-col h-screen overflow-hidden" data-id="element-282">
      <div className="flex flex-1 overflow-hidden" data-id="element-283">
        <Sidebar machines={machineData} selectedMachine={selectedMachine} setSelectedMachine={setSelectedMachine} showMainDashboard={showMainDashboard} setShowMainDashboard={setShowMainDashboard} data-id="element-284" />
        <main className="flex-1 overflow-y-auto bg-gradient-to-br from-gray-900 to-gray-800" data-id="element-285">
          <div className="container mx-auto p-6" data-id="element-286">
            {showImpressum ? <div data-id="element-287">
                <button onClick={() => setShowImpressum(false)} className="mb-4 px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-md text-sm" data-id="element-288">
                  Zurück
                </button>
                <Impressum data-id="element-289" />
              </div> : <>
                <h1 className="text-2xl font-bold mb-6 text-gray-100" data-id="element-290">
                  Maschinendaten-Überwachungssystem
                </h1>
                {showMainDashboard ? <MainDashboard machineData={machineData} data-id="element-291" /> : <Tabs defaultValue="dashboard" data-id="element-292">
                    <TabsList className="mb-6" data-id="element-293">
                      <TabsTrigger value="dashboard" data-id="element-294">Dashboard</TabsTrigger>
                      <TabsTrigger value="history" data-id="element-295">
                        Historische Daten
                      </TabsTrigger>
                    </TabsList>
                    <TabsContent value="dashboard" data-id="element-296">
                      {machine && <Dashboard machine={machine} data-id="element-297" />}
                    </TabsContent>
                    <TabsContent value="history" data-id="element-298">
                      {machine && <HistoryView machine={machine} data-id="element-299" />}
                    </TabsContent>
                  </Tabs>}
              </>}
          </div>
        </main>
      </div>
      {/* Footer */}
      <footer className="bg-gray-800 border-t border-gray-700 py-3 px-6 text-center text-sm text-gray-400" data-id="element-300">
        <button onClick={() => setShowImpressum(true)} className="hover:text-gray-300 transition-colors" data-id="element-301">
          Impressum
        </button>
        <span className="mx-2" data-id="element-302">|</span>
        <span data-id="element-303">© {new Date().getFullYear()} INTIGOO! GmbH</span>
      </footer>
    </div>;
};